module.exports = __webpack_public_path__ + "static/media/step-02.8d935e18.png";